import { identity } from "lodash";
import { FC } from "react";
import { Field } from "react-final-form";
import { Descendant, Editor, Transforms } from "slate";

import { DesignToken } from "@livechat/design-system-react-components";

import { FormattedTextEditor, IVariableSelectParams } from "components/rich-editor/formatted-text-editor";
import { RichTextVariables } from "components/rich-editor/plugins/constants";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { withVar } from "themes/helpers";

interface IProps {
  editorKey?: string;
  cannedResponseID?: string;
  richTextAreaMaxHeight?: string;
  disabled?: boolean;
}

export const CannedRichTextEditor: FC<IProps> = ({ editorKey, cannedResponseID, richTextAreaMaxHeight, disabled }) => (
  <Field<Descendant[]>
    key={editorKey}
    name="cannedRichText"
    parse={identity}
    disabled={disabled}
    placeholder="Enter canned response text..."
    render={FormattedTextEditor}
    transactionType="cannedResponse"
    cannedResponseID={cannedResponseID}
    richTextAreaMinHeight="160px"
    richTextAreaMaxHeight={richTextAreaMaxHeight}
    richTextAreaBackgroundColor={withVar(DesignToken.SurfacePrimaryDefault)}
    toolbarWrap
    // plugins added to the editor
    variablesPlugin
    insertCleanVariables
    handleVariableSelect={(editor: Editor) =>
      ({ label, content }: IVariableSelectParams) => {
        Transforms.insertNodes(editor, {
          type: "textVariable",
          label,
          content,
          children: [{ text: "" }],
        });
        Transforms.move(editor);
        trackEngagement("Canned responses: Add variable from list", EventPlace.Settings, {
          variableAdded: label,
        });
      }}
    variablesPluginOptions={[
      RichTextVariables.RequesterName,
      RichTextVariables.RequesterEmail,
      RichTextVariables.AgentName,
      RichTextVariables.AgentEmail,
      RichTextVariables.ShortID,
    ]}
    linksPlugin
    imagesPlugin
    attachmentsPlugin
    richTextPlugin
    // customizing the richTextPlugin
    withBold
    withItalic
    withUnderline
    withStrikethrough
    withCode
    withNumberedList
    withBulletedList
  />
);
